import React from "react";
import "./Phonetic.css";

export default function Word(props) {
  function capitalizeFirstLetter() {
    return (
      <div className="Phonehero">
        {props.phonetic.charAt(0).toUpperCase() + props.phonetic.slice(1)}
      </div>
    );
  }

  return (
    <div className="Phonetic">{capitalizeFirstLetter(props.phonetic)}</div>
  );
}
